<template>
  <v-app id="inspire">
    <vue-progress-bar></vue-progress-bar>
    <router-view></router-view>
  </v-app>
</template>

<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import globalStore from './store.js'

export default {
  name: 'App',
  mixins: [RegisterStoreModule],
  async created() {
    
    await this.registerStoreModule('global', globalStore)
    // await this.$store.dispatch('global/initComboBox')
    // await this.$store.dispatch('global/initUser')
    // this.$store.dispatch('global/initModules')
    // this.$store.dispatch('global/initHardware')
    // this.$store.dispatch('global/initCountries')
  },
}
</script>
<style lang="scss">
  @import '@/scss/variable.scss';
  @import '@/scss/app.scss';
</style>
